import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import IconAttachment from 'material-ui/svg-icons/editor/attach-file';
import AssetChip from './AssetChip';
import FlatButton from 'material-ui/FlatButton';

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)',
};

const AssetSegmentAdmin = ({assets, addAction, deleteAction}) => (

    <Card className="cent-card">
        <CardHeader
            title="Attachments"
            subtitle="additional files"
            avatar={<IconAttachment {...iconProps}/>}
        />
        <CardText className="cent-card-text">
            {assets.map((asset) => (
                <AssetChip
                    key={asset.id}
                    data={asset}
                    onDelete={() => deleteAction(asset.id)}
                />
            ))}
        </CardText>
        <CardActions>
            <FlatButton label="Add" onTouchTap={addAction} />
        </CardActions>
    </Card>
);

AssetSegmentAdmin.propTypes = {
    assets:         PropTypes.arrayOf(PropTypes.object),
    addAction:      PropTypes.func,
    deleteAction:   PropTypes.func
};

export default AssetSegmentAdmin;
